import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';

import Home from '../pages/Home/Home';

import OurStory from '../pages/About/OurStory';
import OurTeam from '../pages/About/OurTeam';
import WhatWeBelieve from '../pages/About/WhatWeBelieve';
import Financials from '../pages/About/Financials';

import TrainingNationals from '../pages/Missions/TrainingNationals';
import PlantingChurches from '../pages/Missions/PlantingChurches';
import EducatingChildren from '../pages/Missions/EducatingChildren';
import ProvidingHumanitarianAid from '../pages/Missions/ProvidingHumanitarianAid';

import PrayerPartner from '../pages/GetInvolved/PrayerPartner';
import SponsorshipProgramme from '../pages/GetInvolved/SponsorshipProgramme';
import DevelopmentProjects from '../pages/GetInvolved/DevelopmentProjects';
import HumanitarianAid from '../pages/GetInvolved/HumanitarianAid';
import EstatePlanning from '../pages/GetInvolved/EstatePlanning';
import InviteUs from '../pages/GetInvolved/InviteUs';
import GoToIndia from '../pages/GetInvolved/GoToIndia';

import Gallery from '../pages/Resources/Gallery';
import Brochures from '../pages/Resources/Brochures';

import ContactUs from '../pages/Contact/ContactUs';
import NotFound from '../pages/NotFound/NotFound';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />

        {/* About Us */}
        <Route path="our-story" element={<OurStory />} />
        <Route path="our-team" element={<OurTeam />} />
        <Route path="what-we-believe" element={<WhatWeBelieve />} />
        <Route path="financials" element={<Financials />} />

        {/* Our Missions */}
        <Route path="training-nationals" element={<TrainingNationals />} />
        <Route path="planting-churches" element={<PlantingChurches />} />
        <Route path="educating-children" element={<EducatingChildren />} />
        <Route path="providing-humanitarian-aid" element={<ProvidingHumanitarianAid />} />

        {/* Get Involved */}
        <Route path="prayer-partner" element={<PrayerPartner />} />
        <Route path="sponsorship-programme" element={<SponsorshipProgramme />} />
        <Route path="development-projects" element={<DevelopmentProjects />} />
        <Route path="humanitarian-aid" element={<HumanitarianAid />} />
        <Route path="estate-planning" element={<EstatePlanning />} />
        <Route path="invite-us" element={<InviteUs />} />
        <Route path="go-to-india" element={<GoToIndia />} />

        {/* Resources */}
        <Route path="gallery" element={<Gallery />} />
        <Route path="brochures" element={<Brochures />} />

        {/* Contact */}
        <Route path="contact" element={<ContactUs />} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
